<template lang='pug' src='./block-header-section.pug'></template>

<script>
export default {
  props: {
    content: {
      Type: Object,
      default: () => {}
    },
    background: {
      Type: Object,
      default: () => {}
    },
    titlePosition: {
      Type: String,
      default: 'vertical'
    },
    titleAlign: {
      Type: String,
      default: 'center'
    },
    bodyAlign: {
      Type: String,
      default: 'center'
    }
  }
}
</script>



// WEBPACK FOOTER //
// block-header-section.vue?0193cb80